import React, { useEffect, useState } from "react";

const AdUnit = ({ slotId, elementId, sizes, className = "" }) => {
  const adId =
    elementId ||
    `ad-${slotId.replace(/\//g, "-")}-${Math.floor(Math.random() * 1000000)}`;

  // Default to standard banner sizes if not provided
  const adSizes = sizes || [
    [300, 250],
    [336, 280],
  ];

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(() => {
      const slot = googletag.defineSlot(slotId, adSizes, adId);

      if (slot) {
        slot.addService(googletag.pubads());
        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        googletag.display(adId);

        // Hide spinner after ad renders
        setTimeout(() => setIsLoading(false), 1500);
      }
    });

    return () => {
      if (window.googletag && window.googletag.destroySlots) {
        googletag.cmd.push(() => {
          const slots = googletag.pubads().getSlots();
          const slot = slots.find((s) => s.getSlotElementId() === adId);
          if (slot) googletag.destroySlots([slot]);
        });
      }
    };
  }, [slotId, adId, adSizes]);

  return (
    <div
      className={`ad-container flex justify-center items-center overflow-hidden p-4 relative ${className}`}
    >
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-slate-50/50 rounded-xl">
          <div className="w-8 h-8 border-2 border-indigo-500/30 border-t-indigo-500 rounded-full animate-spin" />
        </div>
      )}
      <div id={adId}></div>
    </div>
  );
};

export default AdUnit;

export const AnchorAds = ({ adUnitPath }) => {
  useEffect(() => {
    console.log("adUnitPath", adUnitPath);
    window.googletag = window.googletag || { cmd: [] };

    let anchorSlot;

    window.googletag.cmd.push(() => {
      const isMobile = document.body.clientWidth <= 500;

      anchorSlot = window.googletag.defineOutOfPageSlot(
        adUnitPath,
        isMobile
          ? window.googletag.enums.OutOfPageFormat.TOP_ANCHOR
          : window.googletag.enums.OutOfPageFormat.BOTTOM_ANCHOR,
      );
      console.log("anchorSlot", anchorSlot);
      if (anchorSlot) {
        anchorSlot.addService(window.googletag.pubads());
      }

      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      if (anchorSlot) {
        window.googletag.display(anchorSlot);
      }
    });
  }, []);

  return null; // No div required
};

const REWARD_AD_UNIT = "/269265836/ufreegames.in_reward_001";
let rewardedSlot = null;
let rewardedEvent = null; // evt from rewardedSlotReady - has makeRewardedVisible()
let rewardCallbacks = { onReward: null, onClose: null, onReady: null };
let isAdRewarded = false; // New flag to track if reward was granted

const loadRewardAd = () => {
  window.googletag = window.googletag || { cmd: [] };

  window.googletag.cmd.push(function () {
    if (rewardedSlot) {
      window.googletag.destroySlots([rewardedSlot]);
    }

    rewardedSlot = window.googletag.defineOutOfPageSlot(
      REWARD_AD_UNIT,
      window.googletag.enums.OutOfPageFormat.REWARDED
    );

    if (!rewardedSlot) return;

    rewardedSlot.addService(window.googletag.pubads());
    window.googletag.enableServices();
    window.googletag.display(rewardedSlot);
  });
};

export const prefetchRewardAd = ({ onReward, onClose, onReady }) => {
  rewardCallbacks.onReward = onReward;
  rewardCallbacks.onClose = onClose;
  rewardCallbacks.onReady = onReady;

  window.googletag = window.googletag || { cmd: [] };

  window.googletag.cmd.push(function () {

    if (rewardedSlot) {
      if (rewardedEvent && rewardCallbacks.onReady) rewardCallbacks.onReady();
      return;
    }
    loadRewardAd();
    window.googletag.pubads().removeEventListener("rewardedSlotReady");
    window.googletag.pubads().removeEventListener("rewardedSlotGranted");
    window.googletag.pubads().removeEventListener("rewardedSlotClosed");

    window.googletag.pubads().addEventListener("rewardedSlotReady", function (evt) {
      rewardedEvent = evt;
      if (rewardCallbacks.onReady) rewardCallbacks.onReady();
    });

    window.googletag.pubads().addEventListener("rewardedSlotGranted", function () {
      isAdRewarded = true;
      if (rewardCallbacks.onReward) rewardCallbacks.onReward();
    });

    window.googletag.pubads().addEventListener("rewardedSlotClosed", function () {
      if (isAdRewarded) {
        // User got reward, close the modal
        window.googletag.destroySlots([rewardedSlot]);
        rewardedSlot = null;
        rewardedEvent = null;
        if (rewardCallbacks.onClose) rewardCallbacks.onClose();
      } else {
        window.googletag.destroySlots([rewardedSlot]);
        rewardedSlot = null;
        rewardedEvent = null;
        loadRewardAd();
      }
      isAdRewarded = false; // Reset flag for next time
    });
  });
};

export const showPrefetchedRewardAd = (onOverlayClose) => {
  if (!rewardedEvent || typeof rewardedEvent.makeRewardedVisible !== "function") {
    return false;
  }
  if (onOverlayClose) {
    rewardCallbacks.onClose = onOverlayClose;
  }

  isAdRewarded = false; // Reset before showing

  try {
    rewardedEvent.makeRewardedVisible();
    return true;
  } catch (e) {
    return false;
  }
};

export const isRewardAdReady = () => !!rewardedEvent;


